import React from 'react';
import { css } from 'emotion';
import { neutral, text } from '@guardian/src-foundations/palette';
import { textSans } from '@guardian/src-foundations/typography';
import { between } from '@guardian/src-foundations/mq';
import ShareIcon from '@frontend/static/icons/share.svg';
import { useApi } from '@root/src/web/lib/useApi';
import { formatCount } from '@root/src/web/lib/formatCount';
import { joinUrl } from '@root/src/lib/joinUrl';
const containerStyles = css `
	display: flex;
	align-self: flex-end;
	flex-direction: column;
	${textSans.medium()};
	font-weight: bold;
	color: ${text.supporting};
`;
const iconContainerStyles = css `
	height: 15px;
	margin: 0;
	text-align: right;
	margin-bottom: 3px;
`;
const iconStyles = css `
	fill: ${neutral[46]};
`;
const longStyles = css `
	display: block;

	${between.leftCol.and.wide} {
		display: none;
	}
`;
const shortStyles = css `
	display: none;

	${between.leftCol.and.wide} {
		display: block;
	}
`;
export const ShareCount = ({ ajaxUrl, pageId }) => {
    const shareUrl = joinUrl([ajaxUrl, 'sharecount', `${pageId}.json`]);
    const { data: shareData, error: shareError } = useApi(shareUrl);
    if (shareError) {
        window.guardian.modules.sentry.reportError(shareError, 'share-count');
    }
    const shareCount = shareData && shareData.share_count;
    if (!shareCount || shareCount === 0)
        return null;
    const { short, long } = formatCount(shareCount || 0);
    return (React.createElement("div", { className: containerStyles, "aria-label": `${short} Shares`, "data-cy": "share-counts" },
        React.createElement("div", { className: iconContainerStyles },
            React.createElement(ShareIcon, { className: iconStyles })),
        React.createElement("div", { "data-testid": "long-share-count", className: longStyles, "aria-hidden": "true" }, long),
        React.createElement("div", { "data-testid": "short-share-count", className: shortStyles, "aria-hidden": "true" }, short)));
};
